var map = {
	"./en/pages.json": [
		"890e",
		"api-pages-en-pages-json"
	],
	"./eo-UY/pages.json": [
		"7edce",
		"api-pages-eo-UY-pages-json"
	],
	"./zh-Hans/pages.json": [
		"3c64",
		"api-pages-zh-Hans-pages-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7565";
module.exports = webpackAsyncContext;